import { render, staticRenderFns } from "./documentSeal.vue?vue&type=template&id=18c6af02&scoped=true"
import script from "./documentSeal.vue?vue&type=script&lang=js"
export * from "./documentSeal.vue?vue&type=script&lang=js"
import style0 from "./documentSeal.vue?vue&type=style&index=0&id=18c6af02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c6af02",
  null
  
)

export default component.exports